import { useEffect, useState } from "react"
import useLocalState from "./useLocalState"


const useVirtuosoSnapshot = (uniqueName, firstRenderRef={ current: false }, listRef={ current: null }, scrollRef) => {
  const [snapshot, setSnapshot] = useLocalState(`infinite-load-items-snapshot-${uniqueName}`, {})
  // const [snapshot, setSnapshot] = useState({})
  // WARNING: THIS IS EXTREMELY IMPORTANT TO LOAD THE STATE CORRECTLY
  //          WE HAVE TO LOAD IT CONDITIONALLY BECAUSE LOADING IN THE
  //          WRONG OR EMPTY STATE CAUSES MAJOR RENDERING ISSUES
  const restoreStateProp = { [Object.keys(snapshot).length > 0 ? 'restoreStateFrom' : '']: snapshot }

  // NOTE: The below code needs to go into the child component to track mounting and unmounting
  // ALSO NOTE: We could also remove the logic from here and just create a hook that puts it directly in the conversation component where Virtuoso is. That probably makes for better separation of concerns
  // Set snapshot on page unmount
  useEffect(() => {
    return () => createSnapshot()
  }, [])

  // Sets snapshot for page refresh
  useEffect(() => {
    window.onbeforeunload = () => createSnapshot()
    return () => { window.onbeforeunload = null }
  }, []);

    // WARNING: THIS IS ALSO EXTRMELY IMPORTANT FOR STUPID REASONS
  //          For some reason, even when you pass in ALL OF THE CORRECT STATE
  //          Virtuoso will sometimes reset the scrollTop to 0 after using
  //          resetStateFrom prop for navigations.
  // WARNING: EVEN MORE STUPIDLY React StrictMode keeps resetting the feedSnapshot
  //          scrollTop when it causes our useEffects to save a new one on page
  //          loads, which isn't even supposed to happen because those hooks should
  //          only run while unmounting. This is the reason you're turning off
  //          React's StrictMode by default unless you think it will be useful.
  //          - if you keep strictmode on and leave the below code, then you'll get
  //            scrolled to the top of the page every navigation.
  //          - if you comment out the below code, you can't fix the random Virtuoso
  //            bug mentioned above. What a conundrum.
  useEffect(() => {
    // NOTE: If a scrollRef isn't passed, ignore this. We haven't seemed to have this issue outside the feeds early on.
    if (scrollRef && snapshot?.scrollTop) {
      if (scrollRef.scrollTop === 0 && snapshot?.scrollTop !== 0) {
        scrollRef.scrollTop = snapshot?.scrollTop || 0
      }
    }
  }, [scrollRef])
  
  // WARNING: If this function runs right away, then it will save the initial state over the existing one
  //          when the initial render happens. React Strictmode WILL cause this.
  // WARNING: Things can go wrong VERY BADLY when the page loads without the snapshot (hence the dynamic restoreState object/prop above)
  //          MAKE DAMN SURE when the page loads without the snapshot in storage that the page loads correctly and efficiently.
  //          It shouldn't take more than a second at most to load items from localstorage.
  const createSnapshot = () => {
    if (firstRenderRef.current === false) {
      listRef?.current?.getState((snapshot) => {
        setSnapshot(snapshot)
      })
    }
  }

  return {
    restoreStateProp,
    createSnapshot,
    snapshot,
  }
}

export default useVirtuosoSnapshot
